<div *ngIf="HAS_DISPLAY_FIELDS === true">
  <div *ngFor="let col of WALLETS" class="cell_">
    <td>
      <div class="label_ mb-1 ml-1">Wallet</div>
      <div class="label-text-value ml-1">
        {{ col.name }} - {{ col.currency }}
      </div>
    </td>
  </div>
</div>
<div *ngIf="HAS_DISPLAY_FIELDS === false">
  <div class="container-view">
    <table class="table table-bordered listing-table">
      <tbody>
        <tr *ngFor="let col of WALLETS" class="cell_">
          <td>
            <div class="label_ mb-1 ml-1">Wallet</div>
            <div class="label-text-value ml-1">
              {{ col.name }} - {{ col.currency }}
            </div>
          </td>
          <td>
            <div class="label_ mb-1 ml-1">Total Balance</div>
            <div class="label-text-value ml-1">${{ col.total_balance }}</div>
          </td>
          <td>
            <div class="label_ mb-1 ml-1">Available Balance</div>
            <div class="label-text-value ml-1">
              ${{ col.available_balance }}
            </div>
          </td>
          <td>
            <div class="label_ mb-1 ml-1">Pending Inflow</div>
            <div class="label-text-value ml-1">
              ${{ col.uncredited_balance }}
            </div>
          </td>
          <td>
            <div class="label_ mb-1 ml-1">Pending Outflow</div>
            <div class="label-text-value ml-1">${{ col.on_hold_balance }}</div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
